import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { IInstallation } from '../../types/installation'

export interface IInstallationsState extends IAjaxBaseState<IInstallation> {
}

const createInitialInstallationsState = (): IInstallationsState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialInstallationsState
}
